import React, { FC } from 'react';
import { Carousel } from '@goldbely/explore-component-library';

import ProductSkeletons from 'src/explore/elements/ProductSkeletons';

import { Products } from './elements/Products';

import styles from './index.module.sass';

interface Props {
  analytics?: Record<string, string>;
  hideLove?: boolean;
  hideMerchant?: boolean;
  linkParameters?: {
    [key: string]: string;
  };
  pristine: boolean;
  products: Array<any>;
  recommId?: string | null;
  template: string;
  title?: string | null;
  viewAllText?: string;
  viewAllLinkUrl?: string;
}

export const ProductCarousel: FC<Props> = ({
  analytics,
  hideLove,
  hideMerchant,
  linkParameters,
  pristine,
  products,
  recommId,
  template,
  title,
  viewAllText = 'View All',
  viewAllLinkUrl,
}) => {
  if ( !products?.length && !pristine ) return null;

  return (
    <div className="spec__product-carousel">
      {title && <h3 className="mb-3 fs-5 fs-lg-8 text-uppercase text-center">{title}</h3>}

      {pristine ? (
        <ProductSkeletons across={4} className="flex-nowrap w-100 overflow-hidden" />
      ) : (
        <Carousel
          classNames={{ container: `${styles.container} spec__collection-products` }}
          element="ul"
          jumpToEdgeChild
        >
          <Products
            analytics={analytics}
            hideLove={hideLove}
            hideMerchant={hideMerchant}
            linkParameters={linkParameters}
            products={products}
            recommId={recommId}
            template={template}
          />
        </Carousel>
      )}

      {viewAllLinkUrl && (
        <div className="px-4 mt-4 text-center">
          <a href={viewAllLinkUrl} className={`${styles.button} btn btn-dark px-9`}>
            {viewAllText}
          </a>
        </div>
      )}
    </div>
  );
};
